var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGender2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326 385.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7200;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2451412629200"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99,97.7c0-27.3,11.3-48.6,35.3-60.7,17-8.5,39.8-8.7,56.7-.3,3.5,1.7,6.1,3.3,9.4,5.6,2.2,1.6,2,1.5,3.9,3.1,5.8,4.7,2.8,1.4,7.6,7.4,1.6,2,1.9,2.1,3.5,4.5,2.3,3.3,3.9,5.9,5.6,9.4,12,24.3,5.5,56.2-13.2,73.8-5.6,5.3-12.1,8.9-18.8,12.2-39.1,19.5-90-12.3-90-55h0Zm-30-11c0,20.3-.1,30.3,9.5,49.5,35.3,70.5,134.9,68.1,168.2,1.2,19.5-39.3,11.9-80.3-18.9-111.4C185.3-17,107.3-5.3,79.3,51c-4.4,8.9-10.3,22.9-10.3,35.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,366.7v5c0,16.7,29.7,19.7,30-2,.5-32.4,11.2-59.3,29.4-82.6,23.2-29.9,64.1-49.4,103.6-49.4s68.1,13.3,87.7,33.3c4.4,4.5,8.9,7.9,15,15,1.8,2.1,3,4,4.7,6.3,13.9,18.4,25.7,49.5,25.6,75.4,0,8.1,1.5,11,6.2,14.8,5.9,4.7,23.8,6,23.8-15.8s-7-46.4-14.7-64.3c-5.9-13.8-14.5-25.3-23.4-36.6l-20-20c-43.1-34-88.5-45.7-143.5-33.7-19.9,4.3-38.8,14.3-55,25C28.9,263.7,0,317.1,0,366.7h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender2);
export default __webpack_public_path__ + "static/media/gender 2.5f966ed41790c459a73b855d1e5e2c6c.svg";
export { ForwardRef as ReactComponent };